import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { HiArrowUpRight } from "react-icons/hi2";
import { kairia } from "../../assets/index";

const item = {
  hidden: { opacity: 0, y: 20, scale: 0.95 },
  show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5 } },
};

const KairiaCell = () => {
  const { t } = useTranslation();

  return (
    <motion.a
      variants={item}
      href="https://kairia.fr/?utm_source=portfolio&utm_medium=referral&utm_campaign=bento"
      target="_blank"
      rel="noopener noreferrer"
      id="projects"
      className="bento-cell p-6 lgl:p-8 flex flex-col justify-between gap-4 group cursor-pointer relative overflow-hidden
                 lgl:col-start-1 lgl:col-end-9 lgl:row-start-4 lgl:row-end-6
                 md:col-span-2"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-designColor/5 via-transparent to-purple-600/5 rounded-2xl" />

      <div className="relative z-10 flex items-center gap-3">
        <span className="px-3 py-1 text-xs font-medium bg-designColor/10 text-designColor rounded-full border border-designColor/20">
          {t("bento.kairia.tag")}
        </span>
      </div>

      <div className="relative z-10 flex items-center gap-5">
        <img
          src={kairia}
          alt="Kairia"
          className="w-14 h-14 rounded-xl object-cover shadow-lg"
        />
        <div className="flex-1">
          <h3 className="text-2xl font-bold text-white font-titleFont flex items-center gap-2">
            {t("bento.kairia.title")}
            <HiArrowUpRight className="text-gray-500 group-hover:text-designColor group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-300" />
          </h3>
          <p className="text-sm text-gray-400 mt-1 leading-relaxed max-w-lg">
            {t("bento.kairia.description")}
          </p>
        </div>
      </div>

      <div className="relative z-10">
        <span className="inline-flex items-center gap-2 text-sm font-medium text-designColor group-hover:gap-3 transition-all duration-300">
          {t("bento.kairia.cta")}
          <HiArrowUpRight className="text-xs" />
        </span>
      </div>
    </motion.a>
  );
};

export default KairiaCell;
